import { Button } from '@platform/components';

type SignUpUsingEmailButtonProps = {
  onClick: () => void;
};

export const SignUpUsingEmailButton = (props: SignUpUsingEmailButtonProps) => {
  const { onClick } = props;

  return (
    <div className='w-full flex flex-row justify-center items-center pb-8 md:pb-2'>
      <Button size='sm' variant='link-color' onPress={onClick}>
        Sign up using email
      </Button>
    </div>
  );
};
